import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { OnboardingDialogsContext } from "contexts/OnboardingDialogs";
import { useContext } from "react";

import InstagramOnboardingSteps from "features/Auth/Onboarding/InstagramOnboardingSteps";

const styles = {
  formContainer: {
    p: { xs: 3, sm: 5, md: 6 },
  },
  closeIcon: {
    color: "primary.main",
    fontSize: 14,
    position: "absolute",
    right: 10,
    top: 10,
  },
  noOverflow: {
    overflowX: "hidden",
  },
  fullWidth: {
    width: "100%",
  },
};

const InstagramOnboardingDialog = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const {
    instagramOnboardingDialogOpen,
    setInstagramOnboardingDialogOpen,
    setCreateTemplateOnboardingDialogOpen,
  } = useContext(OnboardingDialogsContext);

  const handleClose = () => {
    setInstagramOnboardingDialogOpen(false);
    setCreateTemplateOnboardingDialogOpen(true);
  };

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      fullScreen={isMobileScreen}
      scroll="body"
      open={instagramOnboardingDialogOpen}
      onClose={handleClose}
    >
      <IconButton sx={styles.closeIcon} onClick={handleClose}>
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <DialogContent sx={styles.noOverflow}>
        <InstagramOnboardingSteps
          handleBack={handleClose}
          handleNext={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InstagramOnboardingDialog;
